import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormError } from '../shared/FormError';
import { legalLinks } from '../../data/legal';
import { Spinner } from '../../ui/Spinner';
import { inlineHit } from '../../ui/styles';
import { useSubmit } from '../../hooks/useSubmit';
import { newRequestId, submitQuizLead } from '../../utils/api';
import { quizQuestions } from '../../data/quiz';
import { answersForLead } from './quizRules';
type Props = {
  routineId: string;
  answers: readonly string[];
};

/** "Mail me het protocol": een lead met de antwoorden, zonder nieuwsbrief. */
export function QuizEmailForm({
  routineId,
  answers
}: Props) {
  const [email, setEmail] = useState('');
  const lead = useSubmit(submitQuizLead);
  if (lead.succeeded) {
    return <p role="status" className="mt-6 bg-sand px-4 py-3 text-[14px] text-ink" data-id="element-8401" data-mp="2p29cy4p7dkig">
        Onderweg naar <span className="font-medium" data-id="element-8402" data-mp="j5n9fhbhzg81">{email.trim()}</span>. Je protocol staat over een paar minuten in je inbox.
      </p>;
  }
  return <form onSubmit={e => {
    e.preventDefault();
    lead.submit({
      requestId: newRequestId(),
      email: email.trim(),
      routineId,
      answers: answersForLead(quizQuestions, answers)
    });
  }} aria-busy={lead.submitting} className="mt-6 border-t border-line pt-5" data-id="element-8403" data-mp="3h8cg197cz3bn">
      <label htmlFor="quiz-email" className="text-[13px] text-muted" data-id="element-8404" data-mp="3lzb2yrmuqznv">
        Liever eerst rustig nadenken? Ik mail je het protocol met uitleg.
      </label>
      <div className="mt-3 flex gap-2" data-id="element-8405" data-mp="2yccp81q4a5tn">
        <input id="quiz-email" type="email" required autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="jouw@email.nl" aria-describedby={lead.error ? 'quiz-email-error quiz-email-note' : 'quiz-email-note'} aria-invalid={lead.error ? true : undefined} inputMode="email" className="w-full border-b border-line bg-transparent px-1 py-2.5 text-[16px] text-ink sm:text-[14px] placeholder:text-muted focus:border-ink focus:outline-none" data-id="element-8406" data-mp="2tbyol4quhy5n" />
        <button type="submit" disabled={lead.submitting} className="flex min-w-[7.5rem] items-center justify-center gap-2 whitespace-nowrap rounded-full border border-line px-4 text-[14px] text-ink transition-colors duration-150 ease-soft hover:border-ink disabled:cursor-wait" data-id="element-8407" data-mp="ukvro10nhgp3">
          {lead.submitting ? <>
              <Spinner data-id="element-8408" data-mp="6tzrogm1jf6r" />
              <span className="sr-only" data-id="element-8409" data-mp="bunqvpkfb2c2">Bezig met versturen</span>
            </> : 'Stuur maar'}
        </button>
      </div>
      <FormError id="quiz-email-error" message={lead.error} className="mt-3" data-id="element-8410" data-mp="gsp968a0yxmh" />
      <p id="quiz-email-note" className="mt-2 text-[12px] leading-relaxed text-muted" data-id="element-8411" data-mp="llidww5hu5yk">
        Alleen dit advies. Geen nieuwsbrief, tenzij je daar later zelf om vraagt. Lees ons{' '}
        <Link to={legalLinks.privacy} className={`${inlineHit} underline underline-offset-2 hover:text-ink`} data-id="element-8412" data-mp="3p8s8nqqzhfzq">
          privacybeleid
        </Link>
        .
      </p>
    </form>;
}